import { Box, Paper, Typography } from "@mui/material";
import details from "../../../../../data/details.json";
import HomeHelmet from "../../../../../Helmets/HomeHelmet";

export default function HomePage() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        m: 5,
      }}
    >
      <HomeHelmet />
      <Paper sx={{ width: "1000px" }}>
        <Typography
          variant="h6"
          sx={{ p: 1, fontFamily: '"EB Garamond", serif' }}
        >
          {details.greeter}
        </Typography>
      </Paper>

      <Box sx={{ m: 2 }}>
        <img src="/images/home.jpg" alt="Θεραπευτική γωνιά" width="1000px" />
      </Box>
    </Box>
  );
}
